// extracted by mini-css-extract-plugin
export default {"wrapper":"info_wrapper__ICDMp","duckcontainer":"info_duckcontainer__yF0tN","description":"info_description__h7sVq"};